import { Typography } from '@mui/material'
import { ResumeMainPage } from '../ResumeMainPage'

export function RustPage() {
    return (
        <ResumeMainPage index="Programming_Language/Rust">
            <Typography>
                I really admire Rust and am determined to master it. While its syntax can be quite
                challenging, I find the development process invigorating. Rust provides a strong
                sense of security for developers through concepts like borrowing and monads, and I
                often contemplate how everything functions behind the scenes.
            </Typography>
        </ResumeMainPage>
    )
}
